import { LanguageFrontendType } from "../../../pages/shared/components/language/types";

export interface LanguageOptions {
  textKey: string;
  value: LanguageFrontendType;
}

export const languages: LanguageOptions[] = [
  {
    textKey: "LanguageChooser.German",
    value: LanguageFrontendType.de,
  },
  {
    textKey: "LanguageChooser.English",
    value: LanguageFrontendType.en,
  },
  {
    textKey: "LanguageChooser.French",
    value: LanguageFrontendType.fr,
  },
  {
    textKey: "LanguageChooser.Italian",
    value: LanguageFrontendType.it,
  },
];
